export const categories = [
  {
    name: '玄幻',
    icon: 'ri-sword-line',
    desc: '热血升级与宏大世界观，少年剑客逆天改命',
    color: 'primary',
  },
  {
    name: '言情',
    icon: 'ri-heart-3-line',
    desc: '甜宠虐恋与细腻情感，书写人间至美情长',
    color: 'accent',
  },
  {
    name: '历史',
    icon: 'ri-ancient-gate-line',
    desc: '铁马金戈与庙堂权谋，重走波澜壮阔的年代',
    color: 'secondary',
  },
  {
    name: '都市',
    icon: 'ri-building-2-line',
    desc: '现代都市中的奇遇与逆袭，平凡里藏锋芒',
    color: 'primary',
  },
  {
    name: '仙侠',
    icon: 'ri-leaf-line',
    desc: '问道长生与御剑山河，缥缈仙境中的修行路',
    color: 'accent',
  },
];

export const novels = [
  {
    id: 'nk-01',
    title: '九霄剑主',
    author: '云中客',
    category: '玄幻',
    cover: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20xianxia%20fantasy%20novel%20cover%20art%2C%20young%20swordsman%20standing%20on%20a%20mountain%20peak%20with%20a%20glowing%20sword%2C%20swirling%20clouds%2C%20dramatic%20warm%20sunrise%20lighting%2C%20painterly%20style&width=400&height=560&seq=peach-cover-01&orientation=portrait',
    status: '连载中',
    wordCount: '326万字',
    rating: 9.6,
    favorites: 128000,
    views: 4520000,
    updateTime: '2026-10-09 18:20',
    latestChapter: '第1286章 剑破九霄',
    intro: '苍梧山下，少年陈九霄背剑而行。他以一柄断剑入道，从边陲小城一路问鼎天下剑道之巅。庙堂之高、江湖之远、仙门之争，皆在这一剑之中。剑锋所指，是为苍生，亦是为心中那口不平之气。',
    tags: ['热血', '升级流', '剑修'],
    featured: true,
    chapters: [
      { id: '01', title: '第一章 断剑少年', updateTime: '2026-06-01 09:12' },
      { id: '02', title: '第二章 苍梧试剑', updateTime: '2026-06-03 20:40' },
      { id: '03', title: '第三章 第一缕剑气', updateTime: '2026-06-08 19:05' },
      { id: '04', title: '第四章 山雨欲来', updateTime: '2026-06-15 21:18' },
      { id: '05', title: '第五章 剑试群雄', updateTime: '2026-06-24 18:52' },
      { id: '06', title: '第六章 白衣剑客', updateTime: '2026-07-02 20:01' },
      { id: '07', title: '第七章 剑冢旧址', updateTime: '2026-07-13 21:33' },
      { id: '08', title: '第八章 一剑破阵', updateTime: '2026-07-28 19:47' },
      { id: '09', title: '第九章 登楼问剑', updateTime: '2026-08-11 20:22' },
      { id: '10', title: '第十章 天下剑会', updateTime: '2026-08-30 18:09' },
      { id: '11', title: '第十一章 剑意通神', updateTime: '2026-09-19 21:55' },
      { id: '12', title: '第1286章 剑破九霄', updateTime: '2026-10-09 18:20' },
    ],
  },
  {
    id: 'nk-02',
    title: '星辰不灭',
    author: '墨白',
    category: '玄幻',
    cover: 'https://readdy.ai/api/search-image?query=Cosmic%20fantasy%20novel%20cover%20art%2C%20starry%20galaxy%20with%20a%20lone%20figure%20floating%2C%20deep%20space%20nebula%2C%20glowing%20constellations%2C%20luminous%20blue%20and%20gold%20atmosphere%2C%20painterly%20detail&width=400&height=560&seq=peach-cover-02&orientation=portrait',
    status: '连载中',
    wordCount: '215万字',
    rating: 9.3,
    favorites: 96000,
    views: 3180000,
    updateTime: '2026-10-08 20:45',
    latestChapter: '第892章 星海尽头',
    intro: '当第九颗星辰坠落，沉睡万年的星魂再次苏醒。少年陆星辞背负着灭门的秘密，踏上寻找星辰碎片的旅途。他终将明白，所谓命运，不过是强者写给弱者的谎言。',
    tags: ['星空', '热血', '复仇'],
    featured: true,
    chapters: [
      { id: '01', title: '第一章 坠落之夜', updateTime: '2026-05-12 10:20' },
      { id: '02', title: '第二章 星魂觉醒', updateTime: '2026-05-19 21:04' },
      { id: '03', title: '第三章 第一枚碎片', updateTime: '2026-05-27 19:31' },
      { id: '04', title: '第四章 星海囚徒', updateTime: '2026-06-06 20:48' },
      { id: '05', title: '第五章 光年之遥', updateTime: '2026-06-20 21:12' },
      { id: '06', title: '第六章 破碎的星座', updateTime: '2026-07-05 18:40' },
      { id: '07', title: '第七章 星君降临', updateTime: '2026-07-22 20:55' },
      { id: '08', title: '第八章 不灭的誓言', updateTime: '2026-08-09 21:33' },
      { id: '09', title: '第九章 逆命者', updateTime: '2026-08-27 19:08' },
      { id: '10', title: '第十章 星域之门', updateTime: '2026-09-15 20:26' },
      { id: '11', title: '第十一章 众星俯首', updateTime: '2026-09-28 21:47' },
      { id: '12', title: '第892章 星海尽头', updateTime: '2026-10-08 20:45' },
    ],
  },
  {
    id: 'nk-03',
    title: '楚宫阙',
    author: '温晚',
    category: '言情',
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20historical%20romance%20novel%20cover%2C%20graceful%20woman%20in%20fine%20hanfu%20standing%20in%20an%20ancient%20palace%20corridor%2C%20soft%20pink%20blossoms%2C%20warm%20nostalgic%20light%2C%20delicate%20painterly%20style&width=400&height=560&seq=peach-cover-03&orientation=portrait',
    status: '已完结',
    wordCount: '158万字',
    rating: 9.5,
    favorites: 210000,
    views: 5230000,
    updateTime: '2026-09-30 16:10',
    latestChapter: '番外 · 此生长安',
    intro: '她奉旨入宫，本以为此生不过是宫墙里一朵无名花。他执掌天下，冷硬如铁，唯独在她面前低下了头。红墙绿瓦间，一场关于权势与深情的博弈，悄然落子。',
    tags: ['宫廷', '宫斗', 'HE'],
    featured: true,
    chapters: [
      { id: '01', title: '第一章 入宫', updateTime: '2026-03-02 09:30' },
      { id: '02', title: '第二章 初见', updateTime: '2026-03-09 20:15' },
      { id: '03', title: '第三章 一盏宫灯', updateTime: '2026-03-18 19:42' },
      { id: '04', title: '第四章 风起掖庭', updateTime: '2026-03-29 21:06' },
      { id: '05', title: '第五章 棋局', updateTime: '2026-04-12 20:33' },
      { id: '06', title: '第六章 故人旧约', updateTime: '2026-04-28 19:20' },
      { id: '07', title: '第七章 一场春宴', updateTime: '2026-05-16 21:44' },
      { id: '08', title: '第八章 执手之诺', updateTime: '2026-06-04 20:08' },
      { id: '09', title: '第九章 惊变', updateTime: '2026-06-25 21:30' },
      { id: '10', title: '第十章 山河为聘', updateTime: '2026-07-18 20:52' },
      { id: '11', title: '第十一章 尘埃落定', updateTime: '2026-08-22 19:16' },
      { id: '12', title: '番外 · 此生长安', updateTime: '2026-09-30 16:10' },
    ],
  },
  {
    id: 'nk-04',
    title: '许你一世清欢',
    author: '苏念',
    category: '言情',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20modern%20Chinese%20novel%20cover%2C%20tender%20couple%20silhouette%20under%20warm%20street%20lamps%20at%20dusk%2C%20soft%20peach%20tones%2C%20delicate%20emotional%20atmosphere%2C%20painterly%20style&width=400&height=560&seq=peach-cover-04&orientation=portrait',
    status: '连载中',
    wordCount: '96万字',
    rating: 9.2,
    favorites: 87000,
    views: 2460000,
    updateTime: '2026-10-10 09:30',
    latestChapter: '第412章 清欢如你',
    intro: '林清欢是那种看起来什么都不在乎的姑娘，直到遇见把她的名字写进每一页病历的顾医生。一场始于急诊室的相遇，成全了一世清欢。',
    tags: ['都市言情', '甜宠', '治愈'],
    featured: true,
    chapters: [
      { id: '01', title: '第一章 急诊室的夜', updateTime: '2026-05-06 20:00' },
      { id: '02', title: '第二章 他的白大褂', updateTime: '2026-05-14 21:22' },
      { id: '03', title: '第三章 一杯热豆浆', updateTime: '2026-05-25 19:55' },
      { id: '04', title: '第四章 雨夜同行', updateTime: '2026-06-08 20:40' },
      { id: '05', title: '第五章 藏在病历里的名字', updateTime: '2026-06-23 21:08' },
      { id: '06', title: '第六章 不加糖的拿铁', updateTime: '2026-07-10 20:18' },
      { id: '07', title: '第七章 值班的深夜', updateTime: '2026-07-29 19:33' },
      { id: '08', title: '第八章 说出口的心意', updateTime: '2026-08-17 21:50' },
      { id: '09', title: '第九章 异地时光', updateTime: '2026-09-03 20:12' },
      { id: '10', title: '第十章 回到从前', updateTime: '2026-09-21 21:26' },
      { id: '11', title: '第十一章 求婚计划', updateTime: '2026-10-01 20:05' },
      { id: '12', title: '第412章 清欢如你', updateTime: '2026-10-10 09:30' },
    ],
  },
  {
    id: 'nk-05',
    title: '长河落日',
    author: '江左布衣',
    category: '历史',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20epic%20novel%20cover%2C%20ancient%20battlefield%20with%20cavalry%20banners%20at%20golden%20sunset%2C%20vast%20desert%20river%2C%20epic%20cinematic%20mood%2C%20painterly%20detail&width=400&height=560&seq=peach-cover-05&orientation=portrait',
    status: '连载中',
    wordCount: '274万字',
    rating: 9.4,
    favorites: 112000,
    views: 3890000,
    updateTime: '2026-10-07 21:15',
    latestChapter: '第968章 大漠孤烟',
    intro: '北境的风沙里，埋着他兄弟的尸骨，也埋着他的誓言。秦昭从一个败军小卒做起，用十年时间，把一片破碎的山河重新拼回。史书留白处，正是长河落日的开始。',
    tags: ['权谋', '战争', '群像'],
    chapters: [
      { id: '01', title: '第一章 败军之夜', updateTime: '2026-04-02 10:00' },
      { id: '02', title: '第二章 边关小卒', updateTime: '2026-04-15 20:30' },
      { id: '03', title: '第三章 一杆断枪', updateTime: '2026-04-27 21:11' },
      { id: '04', title: '第四章 风雪孤城', updateTime: '2026-05-10 19:48' },
      { id: '05', title: '第五章 诈城之计', updateTime: '2026-05-26 20:55' },
      { id: '06', title: '第六章 将星初现', updateTime: '2026-06-14 21:20' },
      { id: '07', title: '第七章 朝堂风向', updateTime: '2026-07-01 19:35' },
      { id: '08', title: '第八章 三军易帅', updateTime: '2026-07-19 20:42' },
      { id: '09', title: '第九章 血战雁门', updateTime: '2026-08-06 21:15' },
      { id: '10', title: '第十章 天下棋局', updateTime: '2026-08-24 20:06' },
      { id: '11', title: '第十一章 山河可复', updateTime: '2026-09-12 19:52' },
      { id: '12', title: '第968章 大漠孤烟', updateTime: '2026-10-07 21:15' },
    ],
  },
  {
    id: 'nk-06',
    title: '大明匠师',
    author: '顾青山',
    category: '历史',
    cover: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20novel%20cover%2C%20skilled%20craftsman%20in%20a%20Ming%20dynasty%20workshop%20with%20wooden%20tools%20and%20scrolls%2C%20warm%20lantern%20light%2C%20detailed%20artisan%20atmosphere%2C%20painterly%20style&width=400&height=560&seq=peach-cover-06&orientation=portrait',
    status: '已完结',
    wordCount: '189万字',
    rating: 9.1,
    favorites: 76000,
    views: 2140000,
    updateTime: '2026-09-25 17:40',
    latestChapter: '终章 · 匠心',
    intro: '他带着千年后的技艺，重生在永乐年间的匠户之家。当木匠手里的墨斗线拉直了那个时代，一座城、一个王朝，都因他而改变。',
    tags: ['种田', '技艺', '轻松'],
    chapters: [
      { id: '01', title: '第一章 匠户之家', updateTime: '2026-02-08 10:30' },
      { id: '02', title: '第二章 一把好锯', updateTime: '2026-02-22 20:00' },
      { id: '03', title: '第三章 第一笔生意', updateTime: '2026-03-10 19:25' },
      { id: '04', title: '第四章 工匠的名声', updateTime: '2026-03-28 20:14' },
      { id: '05', title: '第五章 入京', updateTime: '2026-04-16 21:02' },
      { id: '06', title: '第六章 营造之才', updateTime: '2026-05-05 20:36' },
      { id: '07', title: '第七章 宫城之难', updateTime: '2026-05-24 19:18' },
      { id: '08', title: '第八章 图纸背后', updateTime: '2026-06-12 20:50' },
      { id: '09', title: '第九章 名动天下', updateTime: '2026-07-02 21:07' },
      { id: '10', title: '第十章 衣锦还乡', updateTime: '2026-07-28 20:22' },
      { id: '11', title: '第十一章 传承', updateTime: '2026-08-25 19:40' },
      { id: '12', title: '终章 · 匠心', updateTime: '2026-09-25 17:40' },
    ],
  },
  {
    id: 'nk-07',
    title: '都市医仙',
    author: '叶知秋',
    category: '都市',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20urban%20fantasy%20novel%20cover%2C%20confident%20young%20doctor%20standing%20before%20a%20city%20night%20skyline%20with%20a%20glowing%20medical%20aura%2C%20cool%20modern%20tones%20with%20warm%20highlights%2C%20cinematic&width=400&height=560&seq=peach-cover-07&orientation=portrait',
    status: '连载中',
    wordCount: '203万字',
    rating: 9.0,
    favorites: 69000,
    views: 1970000,
    updateTime: '2026-10-09 22:05',
    latestChapter: '第756章 银针渡厄',
    intro: '一场意外，让医学院学生叶知秋继承了上古医仙的传承。银针在手，生死判官。都市的霓虹之下，那些藏在病历深处的秘密，正被他一页页翻开。',
    tags: ['都市异能', '医术', '扮猪吃虎'],
    chapters: [
      { id: '01', title: '第一章 银针传承', updateTime: '2026-05-01 20:10' },
      { id: '02', title: '第二章 急诊风云', updateTime: '2026-05-11 21:35' },
      { id: '03', title: '第三章 起死回生', updateTime: '2026-05-23 19:58' },
      { id: '04', title: '第四章 名声鹊起', updateTime: '2026-06-05 20:44' },
      { id: '05', title: '第五章 疑难杂症', updateTime: '2026-06-19 21:20' },
      { id: '06', title: '第六章 高位者的邀请', updateTime: '2026-07-08 20:02' },
      { id: '07', title: '第七章 医者仁心', updateTime: '2026-07-26 19:46' },
      { id: '08', title: '第八章 暗流涌动', updateTime: '2026-08-13 21:12' },
      { id: '09', title: '第九章 一场手术', updateTime: '2026-08-31 20:30' },
      { id: '10', title: '第十章 生死一线', updateTime: '2026-09-18 21:40' },
      { id: '11', title: '第十一章 传承与守护', updateTime: '2026-10-02 20:16' },
      { id: '12', title: '第756章 银针渡厄', updateTime: '2026-10-09 22:05' },
    ],
  },
  {
    id: 'nk-08',
    title: '重回2008',
    author: '陈默',
    category: '都市',
    cover: 'https://readdy.ai/api/search-image?query=Nostalgic%20urban%20novel%20cover%2C%20retro%20early%202000s%20Chinese%20city%20street%20with%20old%20storefronts%2C%20warm%20sepia%20sunlight%2C%20youthful%20memory%20atmosphere%2C%20film%20photography%20style&width=400&height=560&seq=peach-cover-08&orientation=portrait',
    status: '已完结',
    wordCount: '142万字',
    rating: 9.3,
    favorites: 98000,
    views: 2780000,
    updateTime: '2026-09-12 18:30',
    latestChapter: '终章 · 那个夏天',
    intro: '一觉醒来，陈默回到了那个蝉鸣聒噪的夏天，高考倒计时牌立在教室墙上。这一次，他要把所有错过的、弄丢的，一样一样重新赢回来。',
    tags: ['重生', '青春', '爽文'],
    chapters: [
      { id: '01', title: '第一章 那个夏天', updateTime: '2026-01-15 10:15' },
      { id: '02', title: '第二章 倒计时牌', updateTime: '2026-01-28 20:05' },
      { id: '03', title: '第三章 第一桶金', updateTime: '2026-02-14 19:36' },
      { id: '04', title: '第四章 同桌的你', updateTime: '2026-03-02 20:48' },
      { id: '05', title: '第五章 时代风口', updateTime: '2026-03-20 21:10' },
      { id: '06', title: '第六章 高考那天', updateTime: '2026-04-08 19:52' },
      { id: '07', title: '第七章 大学序章', updateTime: '2026-04-29 20:22' },
      { id: '08', title: '第八章 第一次创业', updateTime: '2026-05-20 21:04' },
      { id: '09', title: '第九章 起落之间', updateTime: '2026-06-15 20:40' },
      { id: '10', title: '第十章 久别重逢', updateTime: '2026-07-12 19:28' },
      { id: '11', title: '第十一章 与时代同行', updateTime: '2026-08-10 20:55' },
      { id: '12', title: '终章 · 那个夏天', updateTime: '2026-09-12 18:30' },
    ],
  },
  {
    id: 'nk-09',
    title: '青云问道',
    author: '白鹿客',
    category: '仙侠',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20immortal%20cultivation%20novel%20cover%2C%20lone%20cultivator%20on%20a%20floating%20misty%20mountain%20with%20an%20ancient%20temple%2C%20ethereal%20green%20mist%2C%20serene%20mystical%20mood%2C%20painterly%20style&width=400&height=560&seq=peach-cover-09&orientation=portrait',
    status: '连载中',
    wordCount: '298万字',
    rating: 9.5,
    favorites: 143000,
    views: 4120000,
    updateTime: '2026-10-10 07:20',
    latestChapter: '第1024章 大道归一',
    intro: '青云山巅，一问三千年。少年沈青云资质平平，却以一颗赤子之心叩开仙门。当同门争相攀附、世人皆求捷径，他偏要一步一步，走出属于自己的大道。',
    tags: ['仙侠', '热血', '济世'],
    featured: true,
    chapters: [
      { id: '01', title: '第一章 放牛少年', updateTime: '2026-04-05 09:45' },
      { id: '02', title: '第二章 仙门收徒', updateTime: '2026-04-18 20:12' },
      { id: '03', title: '第三章 最差的弟子', updateTime: '2026-05-02 21:30' },
      { id: '04', title: '第四章 一颗灵种', updateTime: '2026-05-17 19:40' },
      { id: '05', title: '第五章 雨中悟道', updateTime: '2026-06-01 20:58' },
      { id: '06', title: '第六章 同门之争', updateTime: '2026-06-18 21:22' },
      { id: '07', title: '第七章 下山历练', updateTime: '2026-07-06 20:14' },
      { id: '08', title: '第八章 人间疾苦', updateTime: '2026-07-24 19:36' },
      { id: '09', title: '第九章 剑指苍穹', updateTime: '2026-08-14 21:05' },
      { id: '10', title: '第十章 青云会武', updateTime: '2026-09-02 20:48' },
      { id: '11', title: '第十一章 问道于天', updateTime: '2026-09-22 19:20' },
      { id: '12', title: '第1024章 大道归一', updateTime: '2026-10-10 07:20' },
    ],
  },
  {
    id: 'nk-10',
    title: '洛水修仙传',
    author: '青荷',
    category: '仙侠',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20xianxia%20novel%20cover%2C%20graceful%20female%20cultivator%20by%20a%20lotus%20river%20in%20flowing%20white%20robes%20with%20petals%20drifting%2C%20soft%20pastel%20tones%2C%20dreamy%20ethereal%20atmosphere%2C%20painterly&width=400&height=560&seq=peach-cover-10&orientation=portrait',
    status: '连载中',
    wordCount: '167万字',
    rating: 9.2,
    favorites: 81000,
    views: 2050000,
    updateTime: '2026-10-06 20:35',
    latestChapter: '第624章 洛水有灵',
    intro: '洛水之畔的少女苏绾，天生灵根残缺，却能与百草相通。当世人皆道她无法修仙，她已在洛水之间，悟出了独属于自己的道。仙途漫漫，她只愿此生不负己心。',
    tags: ['女频仙侠', '成长', '唯美'],
    chapters: [
      { id: '01', title: '第一章 洛水少女', updateTime: '2026-05-08 10:05' },
      { id: '02', title: '第二章 残缺灵根', updateTime: '2026-05-21 20:32' },
      { id: '03', title: '第三章 草木有灵', updateTime: '2026-06-03 21:14' },
      { id: '04', title: '第四章 初入宗门', updateTime: '2026-06-17 19:48' },
      { id: '05', title: '第五章 一株灵草', updateTime: '2026-07-01 20:26' },
      { id: '06', title: '第六章 师姐的刁难', updateTime: '2026-07-16 21:40' },
      { id: '07', title: '第七章 药庐夜话', updateTime: '2026-08-01 20:02' },
      { id: '08', title: '第八章 洛水制药', updateTime: '2026-08-18 19:30' },
      { id: '09', title: '第九章 秘境之行', updateTime: '2026-09-04 21:18' },
      { id: '10', title: '第十章 灵根重铸', updateTime: '2026-09-19 20:44' },
      { id: '11', title: '第十一章 剑舞洛川', updateTime: '2026-09-28 19:56' },
      { id: '12', title: '第624章 洛水有灵', updateTime: '2026-10-06 20:35' },
    ],
  },
  {
    id: 'nk-11',
    title: '凤鸣九霄',
    author: '顾轻舟',
    category: '言情',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20romance%20fantasy%20novel%20cover%2C%20a%20phoenix%20rising%20behind%20a%20noble%20woman%20in%20red%20hanfu%2C%20fiery%20golden%20feathers%2C%20majestic%20warm%20glow%2C%20painterly%20detailed%20style&width=400&height=560&seq=peach-cover-11&orientation=portrait',
    status: '连载中',
    wordCount: '132万字',
    rating: 9.4,
    favorites: 105000,
    views: 2610000,
    updateTime: '2026-10-09 19:50',
    latestChapter: '第488章 凤鸣九霄',
    intro: '她本是名门嫡女，一朝家破人亡，从云端跌入泥沼。凤凰涅槃，浴火重生。这一世，她不再做任人摆布的棋子，而要亲手将这盘棋，下成自己想要的模样。',
    tags: ['重生', '复仇', '大女主'],
    chapters: [
      { id: '01', title: '第一章 烈火焚城', updateTime: '2026-05-04 09:20' },
      { id: '02', title: '第二章 涅槃重生', updateTime: '2026-05-16 20:40' },
      { id: '03', title: '第三章 换了人间', updateTime: '2026-05-30 21:08' },
      { id: '04', title: '第四章 步步为营', updateTime: '2026-06-13 19:52' },
      { id: '05', title: '第五章 故人重逢', updateTime: '2026-06-29 20:30' },
      { id: '06', title: '第六章 一子落定', updateTime: '2026-07-14 21:16' },
      { id: '07', title: '第七章 旧恨新仇', updateTime: '2026-07-30 20:04' },
      { id: '08', title: '第八章 锋芒初露', updateTime: '2026-08-16 19:44' },
      { id: '09', title: '第九章 权力倾轧', updateTime: '2026-09-01 21:22' },
      { id: '10', title: '第十章 王者归来', updateTime: '2026-09-15 20:38' },
      { id: '11', title: '第十一章 天下棋手', updateTime: '2026-09-26 19:14' },
      { id: '12', title: '第488章 凤鸣九霄', updateTime: '2026-10-09 19:50' },
    ],
  },
  {
    id: 'nk-12',
    title: '万古神帝',
    author: '天蚕',
    category: '玄幻',
    cover: 'https://readdy.ai/api/search-image?query=Grand%20fantasy%20novel%20cover%2C%20majestic%20emperor%20on%20a%20throne%20of%20light%20with%20an%20ancient%20dragon%2C%20powerful%20aura%2C%20epic%20warm%20golden%20lighting%2C%20painterly%20detailed%20style&width=400&height=560&seq=peach-cover-12&orientation=portrait',
    status: '已完结',
    wordCount: '412万字',
    rating: 9.6,
    favorites: 256000,
    views: 6890000,
    updateTime: '2026-09-28 15:20',
    latestChapter: '终章 · 万古长青',
    intro: '万古岁月，众生为棋。他从一介庶子起步，历经万般劫难，最终立于诸天之巅。当他回望来路，山河依旧，而他，已是这世间唯一的神帝。',
    tags: ['热血', '无敌流', '圆满'],
    chapters: [
      { id: '01', title: '第一章 庶子', updateTime: '2025-09-02 10:00' },
      { id: '02', title: '第二章 觉醒血脉', updateTime: '2025-10-15 20:20' },
      { id: '03', title: '第三章 家族试炼', updateTime: '2025-11-28 19:48' },
      { id: '04', title: '第四章 一战成名', updateTime: '2026-01-10 20:35' },
      { id: '05', title: '第五章 踏入中州', updateTime: '2026-02-24 21:12' },
      { id: '06', title: '第六章 神帝遗迹', updateTime: '2026-04-08 20:06' },
      { id: '07', title: '第七章 诸天浩劫', updateTime: '2026-05-22 19:40' },
      { id: '08', title: '第八章 登临苍穹', updateTime: '2026-06-30 21:28' },
      { id: '09', title: '第九章 众生俯首', updateTime: '2026-08-05 20:14' },
      { id: '10', title: '第十章 最后一战', updateTime: '2026-09-01 19:52' },
      { id: '11', title: '第十一章 大道之上', updateTime: '2026-09-18 20:42' },
      { id: '12', title: '终章 · 万古长青', updateTime: '2026-09-28 15:20' },
    ],
  },
];

export const chapterParagraphs = [
  '风从山谷里吹过来，带着草木和泥土的气息。他站在那里，很久没有说话。远处的天边，一抹橘红正慢慢漫开，把层层叠叠的云染成了温柔的颜色。',
  '“你终究还是来了。”苍老的声音在殿中回荡，像是积了几十年的尘埃忽然被惊动。他抬头望去，只见高台之上，一位白须老者负手而立，目光深不见底。',
  '剑光一闪，快得像一道闪电劈开夜色。围观之人只觉眼前一花，再定睛时，胜负已分。那柄剑仍旧悬在半空，剑尖上滴落一滴血，落在青石板上，溅开一朵小小的花。',
  '他想起很多年前的那个雨夜。那时他还是个孩子，蜷缩在破庙的角落里，听雨水敲打残破的瓦片。有人在黑暗中拉起了他的手，掌心的温度，他记了一辈子。',
  '“修行从来不是独行。”师父临终前的话，像一颗种子，落在他心里许多年。如今,当他站在山巅回望，终于明白了那句话的分量——江湖路远，总有人与你同行。',
  '夜雾弥漫，街灯在水汽里晕成一个个朦胧的光团。她抱着书走过长街，脚步声在空荡的巷子里回响。忽然，身后传来一阵不急不缓的脚步声，不近，也不远。',
  '棋盘上黑白交错，看似随意，实则步步杀机。他执起一枚黑子，指尖摩挲片刻，轻轻落下。“这一子，我埋了三年。”他缓缓开口，眼中锋芒尽显。',
  '“人这一生，总要为点什么。”他低声说，也不知是对谁说。风吹动他的衣袖，猎猎作响。身后，是万家灯火；身前，是万里征途。他迈开步子，走进了那漫漫长夜。',
  '药香在屋内静静弥漫。她把最后一味药材放进瓦罐，火苗舔着罐底，咕嘟咕嘟地响。窗外月色正好，照在她专注的侧脸上，安静地像一幅画。',
  '那一刻，天地仿佛都静了下来。他听见自己的心跳，一下，又一下，沉稳而有力。所有的等待，所有的隐忍，都是为了此刻。他握紧了手中的剑，向前一步。',
  '“过去的事，就让它过去吧。”她转过身，语气轻得像叹息。可他知道，那些被岁月掩埋的往事，从未真正离开。有些伤，会跟着人走很远很远的路。',
  '晨光穿过窗棂，在地上投下整齐的光斑。他站起身来，活动了一下有些僵硬的手指。新的一天开始了，而他要走的路，还很长很长。但只要方向对了，慢一点也无妨。',
];